// cinematic/streamFor.ts (CX4) - the ONE way a LiveHandModel becomes the HandStream the cinematic felt plays.
// Every lens (Observe/Diagnose/Solo) and the dev harness build the stream through here, so the felt renders
// the same table skin, seat identity, and hero dock in all three - the "one renderer" discipline starts with
// one stream source. The seat LABELS are stable physical descriptors (the signed-off CX2 look): you identify
// a man by where he sits and what he wears, then tag your READ onto him - the read persists on the SESSION
// (TB3/TB4), not on the stream, which carries only the join key + a fallback label.
import type { HandStream } from '../engine/frameStream';
import { frameStreamFrom } from '../engine/frameStream';
import type { LiveHandModel } from '../engine/liveRunner';

/** Physical descriptors by SEAT index (seat 0 is hero). Stable across a session so a pod is the same man hand
 *  to hand - the continuity the persistent table is built on. Ring holds up to 8 villains (9-handed). */
export const SEAT_LABELS = [
  'You',
  'Grey beard',
  'Headphones',
  'Hoodie',
  'Visor',
  'Ball cap',
  'Sunglasses',
  'Track jacket',
  'Cardigan',
] as const;

export const labelForSeat = (seat: number): string => SEAT_LABELS[seat] ?? `Seat ${seat}`;

/** Build the cinematic frame stream for a played (or provisionally pro-filled) hand model. */
export const streamFor = (model: LiveHandModel): HandStream =>
  frameStreamFrom({
    initial: model.initial,
    terminal: model.terminal,
    seed: model.seed,
    heroSeat: model.heroSeat,
    heroCards: model.heroCards,
    seats: model.terminal.players.map((p) => ({ seat: p.seat, label: labelForSeat(p.seat) })),
  });
